export default {
    title: 'Interview Check-in',
    abnormal_404: 'Oops, the page you are looking for is missing...',
    abnormal_404_sub: 'Please check that URL is correct',
    confirm: 'OK',
    cancel: 'Cancel',
    VerifyWithIdentity: 'Verify your identity',
    enterPhone: 'Please enter your mobile number',

    // m-select-tree
    'mselect.placeholderIndex': 'Please choose',
    'mselect.countryAndCityTreePlaceholder': 'Search',
    'mselect.TreeSelectCancel': 'Cancel',
    'mselect.countryAndCityTreeTitle': 'Select country or region',
    'mselect.notFound': 'Not found',

    // login
    phoneErrorMsg: 'Please enter a correct mobile number',
    verificationCode: 'code',
    validCodeFormatError: 'Incorrect code. Try again.',
    resendValidCode: 'Re-send ({second}s)',
    fetchValidCode: 'Get code',
    verifyFrequent: 'Too many attempts. Please try again in 1 minute.',
    validCodeSent: 'Sent',
    login: 'Next',
    loginTitle: 'Identity Verification',
    back: 'Back',

    // back页面
    noInterviewToday: 'No interviews today. Your recent interview information is as follows:',
    noInterview: 'No interview information',
    job: 'Job: ',
    jobWithoutColon: 'Job',
    interviewTime: 'Interview time: ',
    interviewTimeWithoutColon: 'Interview time',
    location: 'Location: ',
    locationWithoutColon: 'Location',

    // interviewList页面
    interviewListTitle: 'Hello {name}, please confirm the interview you are attending to',
    checkIn: 'Check in',

    // 签到成功页面
    checkInSucc: 'Checked in successfully',
    notifiedHRP1: 'HR and interviewer have been notified. Please wait.',
    HR: 'HR:',
    tel: 'Tel:',
    notifiedHRP2: 'if you need help',
    notifiedHRP3: 'Contact HR',
    fillRegistration: 'Fill out registration form',
    editRegistration: 'Update registration form',
    fillRegistrationNotification:
        'You can fill out the information registration form while waiting',
    editRegistrationNotification:
        'You have filled out the information registration form. If you need to <a href={url}>make any changes</a>, please do so now.',

    // 请求失败抛出错误
    MessageNetworkError: 'Network error. Please refresh the page or try again later.',
    MessageHttpError: 'Something went wrong. Please try again later.',
    MessageNetworkDisconnected: 'Network disconnected. Check your network connection.',

    // On-site Apply Interview
    walkInInterview: 'Walk-in interview',
    applyInterviewTitle: 'If you are already at the interview venue, you can request an interview',
    applyInterviewCTA: 'Apply on site',
    scanWaiting: 'Please show this QR code to your interviewer',
    notAvailableAddress: "This job's location can't be used for interviews.",
    applyInterviewHeader: 'Please confirm the job you are applying for',
    applyInterviewHeaderSingle: 'You have 1 job interview to apply for.',
    applicationTime: 'Application time: ',
    applicationTimeWithoutColon: 'Application time',
    requestNewInterview: 'Request new interview',
    noApplicationsCannotRequest: 'No jobs available for interview application.',
    pleaseSelectLocation: 'Select the interview location',
    searchLocation: 'Search location',
    noInterviewLocation: 'No interview location',
    comma: ', ',
    cannotArrangeInterview: 'Cannot schedule interview at this stage',
    loading: 'Loading',
    refreshQRCode: 'Refresh QR Code'
};
